export const searchEnginesList = [
	{ name: 'Alibaba', value: 'alibaba' },
	{ name: 'AliExpress', value: 'aliexpress' },
	{ name: 'Adidas', value: 'adidas' },
	{ name: 'Amazon', value: 'amazon' },
	{ name: 'Awwwards', value: 'awwwards' },
	{ name: 'Baidu', value: 'baidu' },
	{ name: 'Behance', value: 'behance' },
	{ name: 'Best Buy', value: 'best buy' },
	{ name: 'Bing', value: 'bing' },
	{ name: 'Bloomberg', value: 'bloomberg' },
	{ name: 'Brave', value: 'brave' },
	{ name: 'Canva', value: 'canva' },
	{ name: 'CraigsList', value: 'craigslist' },
	{ name: 'Dictionary.com', value: 'dictionary.com' },
	{ name: 'DuckDuckGo', value: 'duckduckgo' },
	{ name: 'Ebay', value: 'ebay' },
	{ name: 'Economist', value: 'economist' },
	{ name: 'Etsy', value: 'etsy' },
	{ name: 'Expedia', value: 'expedia' },
	{ name: 'Facebook', value: 'facebook' },
	{ name: 'Flipkart', value: 'Flipkart' },
	{ name: 'Forbes', value: 'forbes' },
	{ name: 'Indeed', value: 'indeed' },
	{ name: 'Investopedia', value: 'investopedia' },
	{ name: 'Imdb', value: 'imdb' },
	{ name: 'Google', value: 'google' },
	{ name: 'Google Drive', value: 'gdrive' },
	{ name: 'Github', value: 'github' },
	{ name: 'Gitlab', value: 'gitlab' },
	{ name: 'Grubhub', value: 'grubhub' },
	{ name: 'GScholar', value: 'gscholar' },
	{ name: 'Kylie Cosmetics', value: 'kylie cosmetics' },
	{ name: 'Linkedin', value: 'linkedin' },
	{ name: 'Lonely Planet', value: 'lonely planet' },
	{ name: 'Monster', value: 'monster' },
	{ name: 'Netflix', value: 'netflix' },
	{ name: 'Nike', value: 'nike' },
	{ name: 'Pinterest', value: 'pinterest' },
	{ name: 'Reddit', value: 'reddit' },
	{ name: 'Reddit Programming', value: 'reddit programming' },
	{ name: 'Reddit Startups', value: 'reddit Startups' },
	{ name: 'Reebok', value: 'reebok' },
	{ name: 'Seeking Alpha', value: 'seeking alpha' },
	{ name: 'SimplyHired', value: 'simplyhired' },
	{ name: 'Slideshare', value: 'slideshare' },
	{ name: 'SnapDeal', value: 'snapdeal' },
	{ name: 'SoundCloud', value: 'soundcloud' },
	{ name: 'Stackoverflow', value: 'Stackoverflow' },
	{ name: 'Target', value: 'target' },
	{ name: 'Techcrunch', value: 'techcrunch' },
	{ name: 'TikTok', value: 'tiktok' },
	{ name: 'Tripadvisor', value: 'tripadvisor' },
	{ name: 'Twitter', value: 'twitter' },
	{ name: 'Uber Eats', value: 'uber eats' },
	{ name: 'Uniqlo', value: 'uniqlo' },
	{ name: 'Urban Outfitters', value: 'urban outfitters' },
	{ name: 'Walmart', value: 'walmart' },
	{ name: 'Wikipedia', value: 'wikipedia' },
	{ name: 'Wolfram Alpha', value: 'wolfram alpha' },
	{ name: 'Yahoo', value: 'yahoo' },
	{ name: 'Yandex', value: 'yandex' },
	{ name: 'Youtube', value: 'youtube' }
];
